import * as React from 'react';
import { Input } from '../Form/Input';
import { useAsyncDebounce, } from 'react-table';
import { useHistory } from 'react-router-dom';
export const FilterColumnTableCell = ({ column: { id, filterValue, preFilteredRows, setFilter }, }) => {
    const history = useHistory();
    const count = preFilteredRows.length;
    const onChange = useAsyncDebounce((value) => {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set(id, value);
        history.push(location.pathname + '?' + searchParams.toString());
    }, 500);
    return (React.createElement(Input, { size: "sm", name: id + '-filter', value: filterValue || '', onChange: (e) => {
            setFilter(e.target.value || undefined);
            onChange(e.target.value);
        }, placeholder: `Search...` }));
};
//# sourceMappingURL=FilterColumnTableCell.js.map